// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../_fonts/gentiumbasic--v19--latin-ext_italic--WnzjHAw9aB_JD2VGQVR80We3LAi5hBo7UIM.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../_fonts/gentiumbasic--v19--latin_italic--WnzjHAw9aB_JD2VGQVR80We3LAi5iho7.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../_fonts/gentiumbasic--v19--latin-ext_italic_bold--WnzmHAw9aB_JD2VGQVR80We3LAixMT8uYaKMXBU.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../_fonts/gentiumbasic--v19--latin_italic_bold--WnzmHAw9aB_JD2VGQVR80We3LAixMT8ub6KM.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../_fonts/gentiumbasic--v19--latin-ext--Wnz9HAw9aB_JD2VGQVR80We3LAOJiAI_.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../_fonts/gentiumbasic--v19--latin--Wnz9HAw9aB_JD2VGQVR80We3LA2JiA.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../_fonts/gentiumbasic--v19--latin-ext_bold--WnzgHAw9aB_JD2VGQVR80We3JLasnTMebbqI.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../_fonts/gentiumbasic--v19--latin_bold--WnzgHAw9aB_JD2VGQVR80We3JLasnT0ebQ.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* latin-ext */
@font-face {
  font-family: 'Gentium Basic';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Gentium Basic';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Gentium Basic';
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Gentium Basic';
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Gentium Basic';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Gentium Basic';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Gentium Basic';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Gentium Basic';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

* {
    box-sizing: border-box;
    border-collapse: collapse;
    color: #FFF;
    font-display: optional;
    font-family: "Gentium Basic", serif;
    font-variant-numeric: oldstyle-nums;
}
a,
a * {
    color: #C0C000;
    text-decoration: none;
}
a:active,
a:active *,
a:focus,
a:focus * {
    text-decoration: underline;
}
a:hover,
a:hover * {
    color: #0F0;
}
a[itemprop="sameAs"] > img {
    display: inline-block;
    width: 32px;
    height: 32px;
}
abbr[title] {
    text-decoration: none;
}
address {
    display: block;
    width: 50%;
    margin: auto;
    border: none;
    text-align: center;
    font-style: normal;
}
body,
html,
#root,
#rootContainer {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    width: 100%;
    min-height: 100%;
    margin: 0;
    padding: 0;
    background-color: #000;
}
header {
    width: 100%;
}
img {
    display: block;
    margin: auto;
}
img.thumbnail {
    display: inline-block;
    width: auto;
    height: 100px;
    padding: 15px;
    vertical-align: middle;
    cursor: pointer;
}
span.timeRange,
time {
    display: inline-block;
}

.visuallyhidden {
    visibility: hidden;
}

#breadcrumbs {
    width: 50%;
    min-height: 1rem;
}
#breadcrumbs a,
#breadcrumbs a * {
    color: #FFF;
}
#breadcrumbs a:hover,
#breadcrumbs a:hover * {
    color: #C0C000;
}
#breadcrumbs > li {
    position: relative;
    display: inline-block;
}
#breadcrumbs > li:before {
    content: '❧';
    float: left;
    margin: 0 1rem;
}
#breadcrumbs > li.current {
    line-height: 200%;
}
#breadcrumbs > li.current:before {
    content: '☞';
    font-size: 200%;
}

#homepageLogo {
    width: 100px;
    max-width: 70%;
    height: auto;
    margin: 2rem 15% 1rem;
}

#pageTitle {
    font-size: 2.5rem;
    line-height: 2.5rem;
    font-weight: normal;
    font-variant-caps: small-caps;
    text-align: center;
}

#root {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 0 20px;
}
#root > footer {
    position: relative;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100px;
    margin-top: auto;
    padding: 1rem;
    font-size: 75%;
    text-align: center;
    background-color: #000;
}
#root > main {
    position: relative;
    left: 0;
    margin: 0 10%;
    top: 0;
    z-index: 0;
}

#siteNav {
    position: fixed;
    left: 0;
    top: 5%;
    z-index: 10000;
    width: 15%;
    height: 90%;
    border-width: 1px 1px 1px 0;
    border-style: solid;
    border-color: #C0C000;
    background-color: #171717;
}
#siteNav a,
#siteNav a h1,
#siteNav a h2,
#siteNav a h3,
#siteNav a h4,
#siteNav a h5,
#siteNav a h6 {
    color: #FFF;
}
#siteNav a:hover,
#siteNav a:hover h1,
#siteNav a:hover h2,
#siteNav a:hover h3,
#siteNav a:hover h4,
#siteNav a:hover h5,
#siteNav a:hover h6 {
    color: #C0C000;
}

#siteNav h2 {
    padding-bottom: 1rem;
    font-size: 18px;
    text-align: center;
}
#siteNav h2,
#siteNav h3,
#siteNav h4 {
    display: inline-block;
    width: 100%;
    margin: auto 0;
    font-size: 100%;
    font-weight: normal;
    vertical-align: middle;
}
#siteNav h3 {
    font-size: 16px;
}
#siteNav h3,
#siteNav h4 {
    padding-left: .25rem;
}
#siteNav h4 {
    font-size: 14px;
}
#siteNav img {
    margin: 2rem auto;
}
#siteNav li {
    border-style: dotted;
    border-width: 0;
}
#siteNav li:hover {
    border-style: solid;
    background: #000;
}
#siteNav ol {
    min-height: 100%;
    margin: 0;
    padding: 0 0 0 10%;
}
#siteNav ol > li {
    padding: .25rem 0 .25rem .25rem;
    border-color: #0F0;
    list-style-type: none;
}
#siteNav ol > li:hover {
    border-width: 0 0 0 1px;
}
#siteNav ol > li ol > li {
    border-color: #F0F;
}
#siteNav ol > li ol > li:hover {
    border-width: 0 0 0 1px;
}
`, "",{"version":3,"sources":["webpack://./src/_styles/default.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAkH;EAClH,iNAAiN;AACnN;AACA,UAAU;AACV;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA2G;EAC3G,yLAAyL;AAC3L;AACA,cAAc;AACd;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA2H;EAC3H,iNAAiN;AACnN;AACA,UAAU;AACV;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAoH;EACpH,yLAAyL;AAC3L;AACA,cAAc;AACd;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAwG;EACxG,iNAAiN;AACnN;AACA,UAAU;AACV;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAkG;EAClG,yLAAyL;AAC3L;AACA,cAAc;AACd;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAiH;EACjH,iNAAiN;AACnN;AACA,UAAU;AACV;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA2G;EAC3G,yLAAyL;AAC3L;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,sBAAsB;IACtB,mCAAmC;IACnC,mCAAmC;AACvC;AACA;;IAEI,cAAc;IACd,qBAAqB;AACzB;AACA;;;;IAII,0BAA0B;AAC9B;AACA;;IAEI,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;;;IAII,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;AACA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,MAAM;IACN,UAAU;AACd;;AAEA;IACI,eAAe;IACf,OAAO;IACP,OAAO;IACP,cAAc;IACd,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;;;;;;;IAOI,WAAW;AACf;AACA;;;;;;;IAOI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;AACtB;AACA;;;IAGI,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;;IAEI,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B","sourcesContent":["/* latin-ext */\n@font-face {\n  font-family: 'Gentium Basic';\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(../_fonts/gentiumbasic--v19--latin-ext_italic--WnzjHAw9aB_JD2VGQVR80We3LAi5hBo7UIM.woff2) format('woff2');\n  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Gentium Basic';\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(../_fonts/gentiumbasic--v19--latin_italic--WnzjHAw9aB_JD2VGQVR80We3LAi5iho7.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Gentium Basic';\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(../_fonts/gentiumbasic--v19--latin-ext_italic_bold--WnzmHAw9aB_JD2VGQVR80We3LAixMT8uYaKMXBU.woff2) format('woff2');\n  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Gentium Basic';\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(../_fonts/gentiumbasic--v19--latin_italic_bold--WnzmHAw9aB_JD2VGQVR80We3LAixMT8ub6KM.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Gentium Basic';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(../_fonts/gentiumbasic--v19--latin-ext--Wnz9HAw9aB_JD2VGQVR80We3LAOJiAI_.woff2) format('woff2');\n  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Gentium Basic';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(../_fonts/gentiumbasic--v19--latin--Wnz9HAw9aB_JD2VGQVR80We3LA2JiA.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Gentium Basic';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(../_fonts/gentiumbasic--v19--latin-ext_bold--WnzgHAw9aB_JD2VGQVR80We3JLasnTMebbqI.woff2) format('woff2');\n  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Gentium Basic';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(../_fonts/gentiumbasic--v19--latin_bold--WnzgHAw9aB_JD2VGQVR80We3JLasnT0ebQ.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n* {\n    box-sizing: border-box;\n    border-collapse: collapse;\n    color: #FFF;\n    font-display: optional;\n    font-family: \"Gentium Basic\", serif;\n    font-variant-numeric: oldstyle-nums;\n}\na,\na * {\n    color: #C0C000;\n    text-decoration: none;\n}\na:active,\na:active *,\na:focus,\na:focus * {\n    text-decoration: underline;\n}\na:hover,\na:hover * {\n    color: #0F0;\n}\na[itemprop=\"sameAs\"] > img {\n    display: inline-block;\n    width: 32px;\n    height: 32px;\n}\nabbr[title] {\n    text-decoration: none;\n}\naddress {\n    display: block;\n    width: 50%;\n    margin: auto;\n    border: none;\n    text-align: center;\n    font-style: normal;\n}\nbody,\nhtml,\n#root,\n#rootContainer {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 0;\n    width: 100%;\n    min-height: 100%;\n    margin: 0;\n    padding: 0;\n    background-color: #000;\n}\nheader {\n    width: 100%;\n}\nimg {\n    display: block;\n    margin: auto;\n}\nimg.thumbnail {\n    display: inline-block;\n    width: auto;\n    height: 100px;\n    padding: 15px;\n    vertical-align: middle;\n    cursor: pointer;\n}\nspan.timeRange,\ntime {\n    display: inline-block;\n}\n\n.visuallyhidden {\n    visibility: hidden;\n}\n\n#breadcrumbs {\n    width: 50%;\n    min-height: 1rem;\n}\n#breadcrumbs a,\n#breadcrumbs a * {\n    color: #FFF;\n}\n#breadcrumbs a:hover,\n#breadcrumbs a:hover * {\n    color: #C0C000;\n}\n#breadcrumbs > li {\n    position: relative;\n    display: inline-block;\n}\n#breadcrumbs > li:before {\n    content: '❧';\n    float: left;\n    margin: 0 1rem;\n}\n#breadcrumbs > li.current {\n    line-height: 200%;\n}\n#breadcrumbs > li.current:before {\n    content: '☞';\n    font-size: 200%;\n}\n\n#homepageLogo {\n    width: 100px;\n    max-width: 70%;\n    height: auto;\n    margin: 2rem 15% 1rem;\n}\n\n#pageTitle {\n    font-size: 2.5rem;\n    line-height: 2.5rem;\n    font-weight: normal;\n    font-variant-caps: small-caps;\n    text-align: center;\n}\n\n#root {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n    padding: 0 20px;\n}\n#root > footer {\n    position: relative;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100px;\n    margin-top: auto;\n    padding: 1rem;\n    font-size: 75%;\n    text-align: center;\n    background-color: #000;\n}\n#root > main {\n    position: relative;\n    left: 0;\n    margin: 0 10%;\n    top: 0;\n    z-index: 0;\n}\n\n#siteNav {\n    position: fixed;\n    left: 0;\n    top: 5%;\n    z-index: 10000;\n    width: 15%;\n    height: 90%;\n    border-width: 1px 1px 1px 0;\n    border-style: solid;\n    border-color: #C0C000;\n    background-color: #171717;\n}\n#siteNav a,\n#siteNav a h1,\n#siteNav a h2,\n#siteNav a h3,\n#siteNav a h4,\n#siteNav a h5,\n#siteNav a h6 {\n    color: #FFF;\n}\n#siteNav a:hover,\n#siteNav a:hover h1,\n#siteNav a:hover h2,\n#siteNav a:hover h3,\n#siteNav a:hover h4,\n#siteNav a:hover h5,\n#siteNav a:hover h6 {\n    color: #C0C000;\n}\n\n#siteNav h2 {\n    padding-bottom: 1rem;\n    font-size: 18px;\n    text-align: center;\n}\n#siteNav h2,\n#siteNav h3,\n#siteNav h4 {\n    display: inline-block;\n    width: 100%;\n    margin: auto 0;\n    font-size: 100%;\n    font-weight: normal;\n    vertical-align: middle;\n}\n#siteNav h3 {\n    font-size: 16px;\n}\n#siteNav h3,\n#siteNav h4 {\n    padding-left: .25rem;\n}\n#siteNav h4 {\n    font-size: 14px;\n}\n#siteNav img {\n    margin: 2rem auto;\n}\n#siteNav li {\n    border-style: dotted;\n    border-width: 0;\n}\n#siteNav li:hover {\n    border-style: solid;\n    background: #000;\n}\n#siteNav ol {\n    min-height: 100%;\n    margin: 0;\n    padding: 0 0 0 10%;\n}\n#siteNav ol > li {\n    padding: .25rem 0 .25rem .25rem;\n    border-color: #0F0;\n    list-style-type: none;\n}\n#siteNav ol > li:hover {\n    border-width: 0 0 0 1px;\n}\n#siteNav ol > li ol > li {\n    border-color: #F0F;\n}\n#siteNav ol > li ol > li:hover {\n    border-width: 0 0 0 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
